<template>
  <div class="dados-pessoais-form">
    <modal-data-form
      :show-modal="store.showModalDataForm"
      :title="title"
      :on-save="onSave"
    >
      <field-group-form>
        <v-row>
          <v-col class="ma-0 py-0 pt-2" cols="12" md="6">
            <v-text-field
              v-model="fields.nome"
              v-mask="{
                mask: [Array(80).fill('X').join('')],
                tokens: { X: { pattern: /[A-zÀ-ú\s\\.]/ } },
                masked: true,
              }"
              outlined
              dense
              background-color="white"
              class="ma-0 pa-0"
              :label="$t('Nome_Completo')"
            />
          </v-col>
          <v-col class="ma-0 py-0 pt-2" cols="12" md="6">
            <validation-provider v-slot="{ errors }" name="email" rules="email">
              <v-text-field
                v-model="fields.email"
                outlined
                dense
                background-color="white"
                class="ma-0 pa-0"
                :label="$t('Email')"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col class="ma-0 py-0 pt-2" cols="12" md="6">
            <v-select
              v-model="fields.genero"
              item-text="label"
              item-value="value"
              outlined
              dense
              background-color="white"
              class="ma-0 pa-0"
              :items="genders"
              :label="$t('Genero')"
            />
          </v-col>
          <v-col class="ma-0 py-0 pt-2" cols="12" md="6">
            <validation-provider
              v-slot="{ errors }"
              name="dataNasc"
              :rules="{ date: dateMask.rule }"
            >
              <v-text-field
                v-model="fields.dataNasc"
                v-mask="dateMask.mask"
                outlined
                dense
                background-color="white"
                class="ma-0 pa-0"
                :label="$t('Data_Nasc')"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col class="ma-0 py-0 pt-2" cols="12" md="6">
            <validation-provider
              v-slot="{ errors }"
              name="cep"
              :rules="{ cep: cepMask.rule }"
            >
              <v-text-field
                v-model="fields.cep"
                v-mask="cepMask.mask"
                outlined
                dense
                background-color="white"
                class="ma-0 pa-0"
                :label="$t('CEP')"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
        </v-row>
      </field-group-form>
      <field-group-form :group-label="$t('Contato_Emergencia')">
        <v-row>
          <v-col class="ma-0 py-0 pt-2" cols="12" md="6">
            <v-text-field
              v-model="fields.nomeContato"
              v-mask="{
                mask: [Array(80).fill('X').join('')],
                tokens: { X: { pattern: /[A-zÀ-ú\s\\.]/ } },
                masked: true,
              }"
              outlined
              dense
              background-color="white"
              class="ma-0 pa-0"
              :label="$t('Nome_Contato')"
            />
          </v-col>
          <v-col class="ma-0 py-0 pt-2" cols="12" md="6">
            <validation-provider v-slot="{ errors }" name="email" rules="email">
              <v-text-field
                v-model="fields.emailContato"
                outlined
                dense
                background-color="white"
                class="ma-0 pa-0"
                :label="$t('Email_Contato')"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col class="ma-0 py-0 pt-2" cols="12" md="6">
            <validation-provider v-slot="{ errors }" name="fone1Contato">
              <v-text-field
                v-model="fields.fone1Contato"
                v-mask="phoneMask"
                outlined
                dense
                background-color="white"
                class="ma-0 pa-0"
                :label="$t('Telefone_1')"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
          <v-col class="ma-0 py-0 pt-2" cols="12" md="6">
            <validation-provider v-slot="{ errors }" name="fone2Contato">
              <v-text-field
                v-model="fields.fone2Contato"
                v-mask="phoneMask"
                outlined
                dense
                background-color="white"
                class="ma-0 pa-0"
                :label="$t('Telefone_2')"
                :error-messages="errors"
              />
            </validation-provider>
          </v-col>
        </v-row>
      </field-group-form>
    </modal-data-form>
  </div>
</template>

<script>
import ModalDataForm from "@/components/forms/modal-data-form";
import FieldGroupForm from "@/components/forms/field-group-form";
import { extend, ValidationProvider } from "vee-validate";
import { email, regex } from "vee-validate/dist/rules";
import { updateData } from "@/services";
import i18next from "i18next";

export default {
  props: {
    title: {
      type: String,
    },
    data: {
      type: Object,
      default: () => ({}),
    },
  },
  components: { FieldGroupForm, ModalDataForm, ValidationProvider },
  data() {
    return {
      fields: {
        nome: "",
        genero: "",
        email: "",
        dataNasc: null,
        cep: "",
        nomeContato: "",
        emailContato: "",
        fone1Contato: "",
        fone2Contato: "",
      },
      genders: [
        { label: "", value: null },
        {
          label: i18next.t("Masculino"),
          value: i18next.t("Masculino").toLowerCase(),
        },
        {
          label: i18next.t("Feminino"),
          value: i18next.t("Feminino").toLowerCase(),
        },
        {
          label: i18next.t("Outros"),
          value: i18next.t("Outros").toLowerCase(),
        },
      ],
    };
  },
  watch: {
    "store.showModalDataForm"() {
      this.fields = { ...this.fields, ...this.data };

      this.fields.dataNasc = this.$options.filters.toLocaleDate(
        this.fields.dataNasc
      );
    },
  },
  computed: {
    store() {
      return this.$store.state;
    },
    phoneMask() {
      return this.$store.state.language === "pt_br"
        ? ["(##) #####-####", "(##) ####-####"]
        : this.$store.state.language === "it"
        ? ["### ## ## ##", "### ## ## ###"]
        : ["### ### ####"];
    },
    dateMask() {
      return this.$store.state.language === "en"
        ? { mask: "####-##-##", rule: /\d{4}-\d{2}-\d{2}/ }
        : { mask: "##/##/####", rule: /\d{2}\/\d{2}\/\d{4}/ };
    },
    cepMask() {
      return this.$store.state.language === "en"
        ? { mask: "#########", rule: /\d{4}-\d{2}-\d{2}/ }
        : { mask: "#####-###", rule: /\d{5}-\d{3}/ };
    },
  },
  beforeMount() {
    this.$store.commit("setShowModalDataForm", false);

    extend("email", {
      ...email,
      message: this.$t("email_invalido"),
    });

    extend("fone", {
      ...regex,
      message: this.$t("telefone_invalido"),
    });

    extend("date", {
      ...regex,
      message: this.$t("data_invalida"),
    });
    extend("cep", {
      ...regex,
      message: this.$t("cep_invalido"),
    });
  },
  methods: {
    onSave() {
      this.fields.dataNasc = this.fields.dataNasc
        .split("/")
        .reverse()
        .join("-");

      updateData(this, "pessoa", this.fields);
    },
  },
};
</script>

<style scoped></style>
